import styled from 'styled-components';

export const PayMethodWorkspaceStyle = styled.div`
  display: grid;
  grid-template-columns: minmax(280px, 0.9fr) minmax(0, 1.6fr);
  align-items: start;
  gap: 24px;
  .method-row {
    display: flex;
    align-items: center;
    gap: 14px;
  }
  .method-select {
    border: 0;
    background: transparent;
    flex: 1;
    padding: 4px 0;
    min-width: 0;
    text-align: left;
    color: inherit;
    cursor: pointer;
  }
  .method-name {
    display: block;
    font-size: 14px;
    font-weight: 600;
  }
  .method-summary {
    display: block;
    color: #626e7f;
    font-size: 12px;
    margin-top: 4px;
    overflow-wrap: anywhere;
  }
  .method-position {
    color: #8a94a2;
    font-size: 11px;
    margin-right: 7px;
    font-variant-numeric: tabular-nums;
  }
  .method-status {
    display: flex;
    align-items: center;
    flex-direction: column;
    gap: 8px;
    font-size: 12px;
    color: #626e7f;
  }
  .method-help {
    padding: 16px 24px;
    color: #626e7f;
    font-size: 12px;
    border-top: 1px solid #edf0f4;
  }
  @media (max-width: 1050px) {
    grid-template-columns: minmax(0, 1fr);
  }
`;

export const BenefitEditorStyle = styled.div`
  .benefit-fields {
    padding: 24px;
  }
  .benefit-label {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
    margin-bottom: 14px;
    font-size: 13px;
    font-weight: 600;
  }
  .benefit-hint {
    color: #626e7f;
    font-size: 12px;
    line-height: 1.6;
    margin: 10px 0 28px;
  }
  .benefit-group {
    margin-bottom: 20px;
  }
  .benefit-group .ant-segmented-item-label {
    min-height: 36px;
    padding: 6px 16px;
    line-height: 24px;
  }
  .benefit-line {
    padding: 20px;
    margin-top: 16px;
    background: #f8f9fc;
    border: 1px solid #edf0f4;
    border-radius: 7px;
  }
  .benefit-line-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 12px;
    margin-bottom: 16px;
  }
  .benefit-line-actions {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .benefit-line-status {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    font-size: 12px;
    color: #626e7f;
  }
  .benefit-preview {
    margin: 0 24px 24px;
    padding: 24px;
    background: #f7f8fb;
    border: 1px solid #edf0f4;
    border-radius: 8px;
  }
  .preview-label {
    display: flex;
    justify-content: space-between;
    color: #626e7f;
    font-size: 12px;
    margin-bottom: 18px;
  }
  .preview-method {
    border: 1px solid var(--settings-accent);
    background: #fff;
    border-radius: 6px;
    padding: 16px;
    text-align: center;
  }
  .preview-badge {
    display: block;
    color: var(--settings-accent);
    font-size: 12px;
    margin-top: 4px;
    overflow-wrap: anywhere;
  }
  .preview-details {
    padding-left: 18px;
    margin: 14px 0 0;
    color: #626e7f;
    font-size: 13px;
  }
  .preview-details li {
    padding: 5px 0;
    overflow-wrap: anywhere;
  }
  @media (max-width: 680px) {
    .benefit-fields,
    .benefit-line {
      padding: 16px;
    }
    .benefit-preview {
      margin: 0 16px 16px;
      padding: 16px;
    }
  }
`;
